import React,{useState} from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './Components/IHCA2025/Header';
import Login from './Components/IHCA2025/Login';
import Lobby from './Components/IHCA2025/Lobby';
import SpeakerList from './Components/IHCA2025/speakers/SpeakerList';
import SpeakerDetails from './Components/IHCA2025/speakers/SpeakerDetails';
import SponsorList from './Components/IHCA2025/sponsors/Sponsors';
import SponsorDetails from './Components/IHCA2025/sponsors/SponsorDetails';
import AttendeesList from './Components/IHCA2025/attendee/Attendees';
import AttendeeDetails from './Components/IHCA2025/attendee/AttendeeDetails';
import ExhibitHall from './Components/IHCA2025/attendee/ExhibitHall';
import ExhibitorDetails from './Components/IHCA2025/attendee/ExhibitorDetails';
import ConferenceSchedule from './Components/IHCA2025/conference/getSession';
import Maps from './Components/IHCA2025/Maps/Maps';
import MapDetail from './Components/IHCA2025/Maps/MapDetail';
import UserProfile from './Components/IHCA2025/UserProfile';
import LoginSplash from './Components/IHCA2025/LoginSplash';
import ExhibitorProfile from './Components/IHCA2025/Exhibitor/profile';
import SpeakerProfile from './Components/IHCA2025/speakers/SpeakerProfile';
import ChatPage from "./TmChat/IHCA2025/chat/ChatPage";
import ChatNotification from "./TmChat/IHCA2025/chat/ChatNotification";

import PrivateRoute from './PrivateRoute';


const MdAPA2024 = () => {
    const [exhibitorToken,setExhibitorToken] = useState(localStorage.getItem('exhibitorToken') || null);

    return (
        <Router>
            <Header exhibitorToken={exhibitorToken} />
            {exhibitorToken?<ChatNotification />:''}
            <Switch>
                {/* <Route path="/" exact component={Login} /> */}
                <Route path="/ihca2025/login/:id" exact render={(props) => <Login setExhibitorToken={setExhibitorToken} {...props}/>} />
                <PrivateRoute path="/ihca2025/loginSplash" exact component={LoginSplash} />
                <PrivateRoute path="/ihca2025/conference" exact component={ConferenceSchedule} />
                <PrivateRoute path="/ihca2025/lobby" exact component={Lobby} />
                <PrivateRoute path="/ihca2025/speakers" exact component={SpeakerList} />
                <PrivateRoute path="/ihca2025/speakers/:id" exact component={SpeakerDetails} />
                <PrivateRoute path="/ihca2025/sponsors" exact component={SponsorList} />
                <PrivateRoute path="/ihca2025/sponsor/:id" exact component={SponsorDetails} />
                <PrivateRoute path="/ihca2025/attendees" exact component={AttendeesList} />
                <PrivateRoute path="/ihca2025/attendee/exhibitHall" exact component={ExhibitHall} />
                <PrivateRoute path="/ihca2025/attendee/exhibitor/:exhibitorId/:title" exact component={ExhibitorDetails} />
                {/* <PrivateRoute path="/mdapa2024/attendee/:emailId/:userId" exact component={AttendeeDetails} /> */}
                <PrivateRoute path="/ihca2025/attendee/:emailId/" exact component={AttendeeDetails} />
                <PrivateRoute path="/ihca2025/maps" exact component={Maps} />
                <PrivateRoute path="/ihca2025/maps/details" exact component={MapDetail} />
                <PrivateRoute path="/ihca2025/user/profile" exact component={UserProfile} />
                <PrivateRoute path="/ihca2025/exhibitor/profile" exact component={ExhibitorProfile} />
                <PrivateRoute path="/ihca2025/speaker/profile" exact component={SpeakerProfile} />
                <PrivateRoute path="/ihca2025/chat" exact component={ChatPage} />
                

            </Switch>
        </Router>
    )
}
export default MdAPA2024;